import { render, staticRenderFns } from "./PreviousMail.vue?vue&type=template&id=b7c18bd6&scoped=true&"
import script from "./PreviousMail.vue?vue&type=script&lang=js&"
export * from "./PreviousMail.vue?vue&type=script&lang=js&"
import style0 from "./PreviousMail.vue?vue&type=style&index=0&id=b7c18bd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c18bd6",
  null
  
)

export default component.exports